"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { DiscoverCategoryPanel } from "@/components/feed/discover-category-panel";
import type { DiscoverMockListing } from "@/components/feed/mockDiscoverData";
import {
  FEED_ACTIVE_TAB_STORAGE_KEY,
  serializeFeedActiveTab,
} from "@/lib/feed/feed-active-tab-persistence";

function useDiscoverCategoryRouteBack() {
  const router = useRouter();
  return useCallback(() => {
    // This page is a drill-down of the Discover tab (reachable from other
    // entry points too, e.g. a direct link) — force "discover" on the way
    // back regardless of whatever tab was last persisted.
    try {
      sessionStorage.setItem(FEED_ACTIVE_TAB_STORAGE_KEY, serializeFeedActiveTab("discover", Date.now()));
    } catch {
      /* private mode */
    }
    router.push("/feed");
  }, [router]);
}

export default function DiscoverCategoryPageClient({
  categorySlug,
  name,
  listings,
  liveBrandId,
  currentUserId,
}: {
  categorySlug: string;
  name: string;
  listings: DiscoverMockListing[];
  liveBrandId?: string | null;
  currentUserId?: string | null;
}) {
  const onBack = useDiscoverCategoryRouteBack();

  return (
    <div className="flex min-h-dvh flex-col pb-[calc(3.5rem+var(--kraahl-safe-bottom))]">
      <DiscoverCategoryPanel
        categorySlug={categorySlug}
        name={name}
        mockListings={listings}
        liveBrandId={liveBrandId}
        currentUserId={currentUserId ?? undefined}
        onBack={onBack}
      />
    </div>
  );
}
